import StartEventHook from './StartEventHook'

export default class TagCssStartHook extends StartEventHook {
  constructor () {
    super('TagCssStartHook')
  }

  async run (remoteConfig) {
    switch (remoteConfig.zoneId()) {
      case 'FmZGONEFFIazV1Ht022W':
        remoteConfig.style('.RC-AD-BOX-MIDDLE { width: 0px !important; height: 0px !important; }')
        break
      default:
        // nothing needed
    }
  }
}
